module.exports = __webpack_public_path__ + "static/media/jasper-11.8ed722ab.jpg";